
import VolumeHigh from "../../../assets/duotone/VolumeHigh.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeHighIcon({ className, dataTestid = "VolumeHighIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeHigh data-testid={dataTestid} className={classes} {...rest} />
  );
}
